<div class="home-card">
    <div class="home-card-main">
        <div class="home-card-welcome">
            Bine ați venit în cadrul portalului operator al Primăriei Sectorului 4!
            <img src="/assets/images/sect4-logo.svg" alt="" />
        </div>
        <div style="background-color: white; height: auto; padding: 25px">
            <div class="row d-flex responsive-card-mobile" *ngFor="let client of clientsWithModules" style="margin-bottom: 20px; justify-content: space-between">
                <div class="col-3 card-description" routerLink="/dashboard/request-page">
                    <!-- <img src="/assets/images/sect4-logo.svg" alt="" /> -->
                    <h2>{{client.display_name}}</h2>
                </div>

                <div class="col-9 ps-3 d-flex flex-column ">
                    <div class="d-flex flex-wrap justify-content-between ">

                        <div class="card-app" *ngFor="let clientModule of client.modules; let i=index" [ngClass]="getClientModuleClass(i, client.modules.length)"
                            routerLink="/dashboard/payments">
                            <div class="card-paragraph">
                                <div class="hash">#{{clientModule.name}}</div>
                                <p>{{clientModule.display_name}}</p>
                            </div>

                            <button style="margin-top: 10px; margin-right: 25px;" class="navigate-button" mat-flat-button (click)="navigateToRoute(clientModule.url_front_end, client.id, clientModule.id)">
                                <mat-icon>chevron_right</mat-icon>
                            </button>

                        </div>

                    </div>

                </div>

            </div>
        </div>
    </div>

    <div class="section-spinner position-absolute" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>